import { Component, Input } from '@angular/core';

@Component({
    selector: 'al-help',
    template: `
      <span class="al-help-popover" id="helpLink">
      <span class="fa fa-circle"><span class="fa fa-question"></span></span>
		<a href="{{url}}" target="{{targetValue}}" aria-haspopup="true" *ngIf="hasLink" id="" href="javascript:void(0);" title="{{value}}">{{value}}</a>
      </span>
  `
})

export class AlHelpComponent {

    // Has help link. Provide true if need Link
    @Input() hasLink: boolean = false;

    // Help Link Value
    @Input() value: string = 'Help';

    // set url value of link
    @Input() url: string = 'http://www.google.com';

    // set target value for window/tab behaviour, default is _blank
    @Input() targetValue: string = '_blank';

}
